import React from 'react';
import { useTranslation } from 'react-i18next';
import PaymentHistoryCard from 'components/reusable/report/cards/PaymentHistoryCard';
import CollapsibleCard from '../../../../../components/reusable/CollapsibleCard';
import { Row } from 'antd';

const PaymentHistory = () => {
  const { t } = useTranslation();

  const paidDebts = {
    companyCode: 111689163,
    creditinfoId: 142803,
    total: 254,
    latestDate: '2025-01-16T00:00:00Z',
    averageDays: 214,
  };

  return (
    <div className="content-blur">
      <PaymentHistoryCard paymentHistoryData={paidDebts}>
        <Row className="space-top-md">
          <CollapsibleCard
            hideByDefault={true}
            title={t('professionalReport.basicData.managersChangeHistory.historicalInformation.title')}
          />
        </Row>
      </PaymentHistoryCard>
    </div>
  );
};

export default PaymentHistory;
